import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-select-all-toggle',
  standalone: true,
  imports: [CommonModule, CheckboxModule, FormsModule],
  templateUrl: './select-all-toggle.component.html',
  styleUrls: ['./select-all-toggle.component.scss']
})
export class SelectAllToggleComponent {
  @Input() disabled: boolean = false;
  @Input() allSelected: boolean = false;
  @Output() selectionChange: EventEmitter<{ checked: boolean }> = new EventEmitter<{ checked: boolean }>();

  onToggleSelectAll(event: any) {
    this.selectionChange.emit({ checked: event.checked });
  }
}
